import React from "react";
import Board from "./board";

export default class Game extends React.Component {
	constructor(props) {
		super(props);
		const arr = [];
		for (let x = 0; x < 7; x++) {
			const inner = [];
			for (let y = 0; y < 6; y++) {
				inner.push(null);
			}
			arr.push(inner);
		}
		this.state = {
			collumns: arr,
			yellowIsNext: true,
			count: 0,
		};
	}

	handleClick(i) {
		if (this.calculateWinner()) return;
		let collumns = this.state.collumns.slice();
		const emptyIndex = collumns[i].indexOf(null);
		if (emptyIndex === -1) return;
		collumns[i][emptyIndex] = this.state.yellowIsNext ? "y" : "r";
		this.setState({
			collumns: this.state.collumns,
			yellowIsNext: !this.state.yellowIsNext,
			count: this.state.count + 1,
		});
	}

	calculateWinner() {
		//no transformation
		let matrix = this.state.collumns.slice();
		let winner;
		winner = this.check4chain(matrix);
		if (winner) return winner;

		// 90° transform
		matrix = [[], [], [], [], [], [], []];
		for (let x = 0; x < 7; x++) {
			for (let y = 0; y < 6; y++) {
				matrix[y][6 - x] = this.state.collumns[x][y];
			}
		}

		winner = this.check4chain(matrix);
		if (winner) return winner;
	}

	check4chain(matrix) {
		if (matrix.some((collumn) => collumn.toString().replace(/,/g, "").includes("yyyy"))) return "yellow";
		if (matrix.some((collumn) => collumn.toString().replace(/,/g, "").includes("rrrr"))) return "red";
	}

	render() {
		const winner = this.calculateWinner();

		let status;
		if (winner) status = "Winner: " + winner;
		else status = `Next player: ${this.state.yellowIsNext ? "yellow" : "red"}`;

		return (
			<div className="game">
				<div className="game-board">
					<Board collumns={this.state.collumns} onClick={(i) => this.handleClick(i)} />
				</div>
				<div className="game-info">
					<div className="status">{status}</div>
				</div>
			</div>
		);
	}
}
